// extracted by mini-css-extract-plugin
export default {"root":"styles_root__ySluA","reviews":"styles_reviews__AO-3f"};